/**
 * @file FinancialBillingPage.jsx
 * @description FINANCIAL department — Billing.
 *
 * Invoices and monthly billing.
 *
 * This file belongs to the FINANCIAL department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for FINANCIAL is made HERE and can never leak into another
 * department's screens. The shared engine underneath (BillingPage) and the backend
 * stay common — only the department-facing page is departmental. Route access
 * is department-gated in utils/permissions.js: only FINANCIAL users (and the
 * super admin) can open it.
 */
import React from 'react';
import BillingPage from '../BillingPage';

const FinancialBillingPage = () => (<BillingPage />);

export default FinancialBillingPage;
